import addReadWriteRecipients from '../actions/addReadWriteRecipients';
import maskRecipientFromFindControl from '../actions/maskRecipientFromFindControl';
import showHideFindResult from '../actions/showHideFindResult';
import datapoints from '../datapoints';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import searchDirectory from '../utils/searchDirectory';
import useTypedAddress from '../utils/useTypedAddress';
import { observer } from 'mobx-react';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
import { logUsage } from 'owa-analytics';
import FindRecipient from 'owa-recipient-common/lib/components/FindRecipient';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import addFindPeopleEntityFromResults from 'owa-recipient-common/lib/utils/addFindPeopleEntityFromResults';
import strings from 'owa-strings/owa-common-strings';
import { isBrowserEdge } from 'owa-user-agent/lib/userAgent';
import * as React from 'react';
import FindRecipientInfo, {
    FindRecipientInfoType,
} from 'owa-recipient-common/lib/components/FindRecipientInfo';

let styles = require('./FindRecipientResult.scss');
let classNames = require('classnames/bind').bind(styles);

export interface FindRecipientResultProps {
    recipientWell: RecipientWellWithFindControlViewState;
    queryInputGetter: () => HTMLElement;
    findRecipientInfoType: FindRecipientInfoType;
}

@observer
export default class FindRecipientResult extends React.Component<FindRecipientResultProps, any> {
    private dismissFindResult = () => {
        showHideFindResult(this.props.recipientWell, false /**shouldShowFindResult */);
    };

    private addRecipientAction = (
        recipientWell: RecipientWellWithFindControlViewState,
        position: number
    ) => (recipientToAdd: FindRecipientPersonaType) => {
        const { name: eventName, customData: customData } = datapoints.AddRecipientFromFindControl;
        addFindPeopleEntityFromResults(recipientWell, recipientToAdd, position);
        logUsage(eventName, customData(position, recipientWell.findResultType));
        addReadWriteRecipients(recipientWell, [{ isValid: true, newPersona: recipientToAdd }]);
    };

    private maskRecipientAction = (recipientWell: RecipientWellWithFindControlViewState) => (
        recipientToMask: FindRecipientPersonaType
    ) => {
        maskRecipientFromFindControl(recipientWell, recipientToMask);
    };

    render() {
        let { recipientWell, queryInputGetter, findRecipientInfoType } = this.props;
        let hasQueryString = !!recipientWell.queryString;
        return recipientWell.shouldShowFindResult ? (
            <Callout
                className={classNames(styles.callout, {
                    animationStop: isBrowserEdge() /* see VSO:13872 Remove on release of RS3 */,
                })}
                onDismiss={this.dismissFindResult}
                gapSpace={10}
                target={queryInputGetter()}
                isBeakVisible={false}
                setInitialFocus={false}
                directionalHint={
                    getRTL() ? DirectionalHint.bottomRightEdge : DirectionalHint.bottomLeftEdge
                }>
                {!hasQueryString && recipientWell.findResultSet.length > 0 && (
                    <div className={styles.suggestedContactsHeaderBox}>
                        <span className={styles.suggestedContactsText}>
                            {strings.findRecipientResult_SuggestedContactsHeader}
                        </span>
                    </div>
                )}
                {recipientWell.findResultSet.length != 0 && (
                    <div className={classNames(styles.scrollContainer, 'customScrollBar')}>
                        <div className={styles.recipientCollection}>
                            {recipientWell.findResultSet.map((result, index) => (
                                <FindRecipient
                                    key={result.EmailAddress.EmailAddress}
                                    findRecipient={result}
                                    isHighlighted={index == recipientWell.findResultHightlightIndex}
                                    addRecipientAction={this.addRecipientAction(
                                        recipientWell,
                                        index
                                    )}
                                    maskRecipientAction={this.maskRecipientAction(recipientWell)}
                                />
                            ))}
                        </div>
                    </div>
                )}
                <FindRecipientInfo
                    infoType={findRecipientInfoType}
                    highlighted={
                        recipientWell.findResultSet.length ==
                        recipientWell.findResultHightlightIndex
                    }
                    numberOfResults={recipientWell.findResultSet.length}
                    searchDirectoryAction={() => searchDirectory(this.props.recipientWell)}
                    useTypedAddressAction={() => useTypedAddress(this.props.recipientWell)}
                    queryString={recipientWell.queryString}
                />
            </Callout>
        ) : null;
    }
}
